;
define("product_list_new.tpl", function(){});

